import { render } from "./Form.vue?vue&type=template&id=7a67a816&ts=true"
import script from "@/composables/pages/master-setting/city-terminal/FormComposable?vue&type=script&lang=ts"
export * from "@/composables/pages/master-setting/city-terminal/FormComposable?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__